import React from "react";

const AboutHero = () => {
  return (
    <section className="bg-[#1a1311] py-20 px-4 text-center">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-6xl font-serif text-white mb-6 tracking-wide">
          About Hirapanna
        </h1>
        <p className="text-lg md:text-xl text-gray-300 font-light tracking-widest uppercase">
          Three decades of trust, tradition, and timeless elegance
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
